export function getOrderedCreditCardProducts<T extends { is_popular: boolean }>(products: T[]) {
  const popularIndex = products.findIndex((product) => product.is_popular);

  if (popularIndex === -1) {
    return products;
  }

  const orderedProducts = [...products];
  const [popularProduct] = orderedProducts.splice(popularIndex, 1);
  orderedProducts.splice(Math.floor(products.length / 2), 0, popularProduct);

  return orderedProducts;
}
